// extracted by mini-css-extract-plugin
module.exports = {"container":"Carousel_container__3qBqP","wrapper":"Carousel_wrapper__1zfy2","carousel":"Carousel_carousel__Jl4cG"};